export default __webpack_public_path__ + "static/7-16340a9fd9379ff18c4e0c7123f2820d.png";